import Image from 'next/legacy/image';

import styles from '../locationPage.module.scss';

type HeaderImageProps = {
  imageSource: string;
  location?: string;
};
const HeaderImage = ({ imageSource, location }: HeaderImageProps) => {
  const local = location || 'United States';
  const defaultImage = `${imageSource}?q=1`;

  return (
    <div className={styles.headerImage}>
      <Image
        blurDataURL={`${defaultImage}`}
        placeholder="blur"
        alt={`HelloTech services ${local} for your in-home services & online support`}
        quality={45}
        layout="fill"
        objectFit="cover"
        src={`${imageSource}?q=35`}
        priority={true}
        fetchPriority="high"
      />
    </div>
  );
};

export default HeaderImage;

/**
 * If we are using TOO much Image Bandwidth, see: https://vercel.com/dashboard/hellotech/usage (Image Optimization)
 * Then do a variation of the following: BUT not, it does lower the score a bit in mobile.
 *
 * // import LazyComponent from '@components/LazyComponent';
 * // import {checkIsBotUA} from '@utils/ui';
 *
 *       <LazyComponent minHeight="300">
 *         {checkIsBotUA() ? (
 *           <img alt={`HelloTech services ${local} for your in-home services & online support`} src={`${defaultImage}&h=200&w=500&fm=webp`} />
 *         ) : (
 *           <Image
 *             blurDataURL={`${defaultImage}`}
 *             placeholder="blur"
 *             alt={`HelloTech services ${local} for your in-home services & online support`}
 *             quality={45}
 *             layout="fill"
 *             objectFit="cover"
 *             src={`${imageSource}?q=35`}
 *             priority
 *           />
 *         )}
 *       </LazyComponent>
 */
/**
 *  Previous
 *  If we go with the lazy component way, uncomment the "initialized" const above and uncomment import of lazyComponent.
 *
 *        <LazyComponent minHeight={`${getHeightByDevice()}px`}>{initialized ? <img alt={`Servicing ${local} with pride`} src={imgSrc} /> : null}</LazyComponent>
 *      <Image blurDataURL={`${imageSource}?q=1`} placeholder="blur" alt={`HelloTech services ${local} for your in-home services & online support`} quality={50} layout="fill" objectFit="cover" src={`${imageSource}?q=30`} priority />
 * */
